import Hotjar from '@hotjar/browser';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initGoogleTag } from './services/gtag';

const GOOGLE_TAG_ID = 'GTM-TCR3HLV'; // Substitua pelo seu ID de rastreamento
initGoogleTag(GOOGLE_TAG_ID);

const siteId = 6420754;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
